import { render } from "./companySearch.vue?vue&type=template&id=0745baa0&scoped=true"
import script from "./companySearch.vue?vue&type=script&lang=js"
export * from "./companySearch.vue?vue&type=script&lang=js"

import "./companySearch.vue?vue&type=style&index=0&id=0745baa0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0745baa0"

export default script